import React from 'react';
import { PropInfo, CodeExample, CopyProps } from '@cimpress/react-components';
import CopyButtonCode from '!raw-loader!./copyButton.jsx';
import CopyButtonDemo from './copyButton.jsx';
import CopyTextCode from '!raw-loader!./copyText.jsx';
import CopyTextDemo from './copyText.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const CopyDocs = () => {
  const propInfos: PropInfo<CopyProps>[] = [
    {
      name: 'variant',
      type: "string ('button' | 'text' | 'inline')",
      default: 'text',
      description: 'The variant of copy component user wants to use. Button, text or inline.',
    },
    {
      name: 'value',
      type: 'string',
      description: <span>The text to copy to clipboard</span>,
    },
    {
      name: 'children',
      type: 'string|Node',
      default: 'Copy',
      description: <span>The content of the button.</span>,
    },
    {
      name: 'hoverText',
      type: 'string',
      description: 'Text to display in tooltip when user covers over component.',
    },
    {
      name: 'successMessage',
      type: 'string',
      default: 'Copied successfully',
      description: <span>The message to show in a Snackbar when copying is finished.</span>,
    },
    {
      name: 'duration',
      type: 'number',
      default: '1500',
      description: 'How long (in milliseconds) to show the success message',
    },
  ];

  return (
    <ComponentDoc<CopyProps> name="Copy" propInfos={propInfos}>
      <CopyTextDemo />
      <CodeExample code={CopyTextCode} />
      <CopyButtonDemo />
      <CodeExample code={CopyButtonCode} />
    </ComponentDoc>
  );
};

export default CopyDocs;
